import React, { useEffect, useState } from "react";
import PayPalButtonComponent from "./PayPalButtonComponent";
import apiClient from '../../services/apiClient';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';


const CreateInvoicePayContent = ({ paidpayment1,duedate,invoicelength }) => {
  const [companylogo, setCompanylogo] = useState();
  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();

  const [paymentamount, setPaymentamount] = useState();

  const [stripid, setstripid] = useState("");

  const [paypalid, setpaypalid] = useState("");


  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);



  useEffect(() => {



    const fetchuserdata = async () => {
      try {
        const response = await apiClient.get(`/userdetaila/${JSON.parse(localStorage.getItem('user')).user.id}`);

        setCompanylogo(response.data.usersdetails[0].Main_Logo ? process.env.REACT_APP_BACKEND_URL + response.data.usersdetails[0].Main_Logo : null);

        setPhone(response.data.usersdetails[0].Phone_Number);
        setCompanyemail(response.data.usersdetails[0].Company_Email);

        if (response.data.usersdetails[0].stripe_id === 'NULL' || response.data.usersdetails[0].stripe_id == null) {
          setstripid("");
        } else {
          setstripid(response.data.usersdetails[0].stripe_id);
        }

        if (response.data.usersdetails[0].paypal_id === 'NULL' || response.data.usersdetails[0].paypal_id == null) {
          setpaypalid("");
        } else {
          setpaypalid(response.data.usersdetails[0].paypal_id);
        }



      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchuserdata();

  }, []);


  // code for stripe payment start


  const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
      event.preventDefault();

      if (!stripe || !elements) {
        return; // Stripe.js has not yet loaded.
      }

      setLoading(true);
      const cardElement = elements.getElement(CardElement);

      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });

      if (error) {
        setError(error.message);
      } else {
        setError(null);



        const response = await apiClient.post(`/transfer`, {
          payment_method_id: paymentMethod.id,
          amount: paidpayment1.length ? paidpayment1[0].amount * 100 : 0,  // Amount in smallest currency unit (e.g., cents for USD)
          currency: 'usd',
          connected_account_id: stripid,
        });


        if (response.data.success) {
          alert('transfer complete sucessfully');
        }






        // You can send the paymentMethod to your backend for further processing.
      }

      setLoading(false);
    };


    // code for stripe payment start


    return (
      <form onSubmit={handleSubmit} style={{ maxWidth: '100%', margin: '0 auto' }}>
        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="card-element" style={{ marginBottom: '10px', display: 'block' }}>
            Card Details
          </label>
          <div style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '10px' }}>
            <CardElement
              options={{
                style: {
                  base: {
                    fontSize: '16px',
                    color: '#424770',
                    '::placeholder': {
                      color: '#aab7c4',
                    },
                    padding: '10px',
                    boxSizing: 'border-box',
                    border: '1px solid #ccc', // Direct border style might not work
                    borderRadius: '4px',
                    padding: '0', // Remove internal padding
                  },
                  invalid: {
                    color: '#9e2146',
                  },
                },
              }}
            />
          </div>
        </div>
        {error && <div style={{ color: 'red' }}>{error}</div>}
        <button
          type="submit"
          disabled={!stripe}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            color: '#fff',
            backgroundColor: '#5469d4',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Pay
        </button>
      </form>
    );
  };





  return (
    <section className='section_container my-4'>
      {/* Customer Details here */}
      <div className='customer_details details_top d-flex align-items-center justify-content-between flex-column flex-md-row column-gap-2'>
        <div className='text-center d-flex align-items-center'>

          {" "}

          {companylogo ? (
            <>
              <div className='logo'>
              
                  <img src={companylogo} alt='Main Logo Preview' className='mainimgpath' style={{height: "150px"}} />
              
              </div>
            </>
          ) : (<>

          </>)}



          <div className='details_text'>
            <h6>Payment 1 of {invoicelength}</h6>
             <span>Due: {duedate}</span>
            {/* <span>{paidpayment1[0].dueDate}</span> */}
          </div>
        </div>
        <div className='title'>
          <h4>View Invoice</h4>
        </div>
      </div>

      {/* payment form area */}
      <div className='payment_form_container px-4 py-5'>
        <div className='due_amount mb-3'>
          <span>Amount Due</span>
          <h4>${paidpayment1.length ? paidpayment1[0].amount : 0} </h4>
        </div>

        <div className='way_to_pay'>
          <label>Please select payment methods below</label>
          <ul
            className='nav nav-pills mb-3 way_to_pay_nav'
            id='pills-tab'
            role='tablist'>

            {stripid !== "" && (
              <li className='nav-item' role='presentation'>
                <button
                  className='nav-link active'
                  id='pills-home-tab'
                  data-bs-toggle='pill'
                  data-bs-target='#pills-home'
                  type='button'
                  role='tab'
                  aria-controls='pills-home'
                  aria-selected='true'>
                  Credit Card
                </button>
              </li>
            )}




            {paypalid !== "" && (
              <li className='nav-item' role='presentation'>
                <button
                  className='nav-link'
                  id='pills-profile-tab'
                  data-bs-toggle='pill'
                  data-bs-target='#pills-profile1'
                  type='button'
                  role='tab'
                  aria-controls='pills-profile'
                  aria-selected='false'>
                  Pay With Paypal
                </button>
              </li>
            )}


          </ul>

          <div className='tab-content' id='pills-tabContent'>
            {/* Credit Form Area */}
            <div
              className={`tab-pane fade active mt-5 ${stripid !== "" ? 'show' : ''}`}
              id='pills-home'
              role='tabpanel'
              aria-labelledby='pills-home-tab'>
              {/*   <form action=''>  */}
              <div className='row'>
                <div className='col-md-12 col-lg-6'>
                  <div className='row'>
                    {/* Card Number field */}
                    {/*  <div className='col-md-12'>
                        <div className='mb-3'>
                          <label htmlFor='fullName' className='form-label'>
                            Card Number
                          </label>
                          <input
                            type='number'
                            name='cardNumber'
                            className='form-control'
                            id='fullName'
                            required
                          />
                        </div>
                      </div> 
                      
                      */}
                    {/* Name on card*/}
                    {/* <div className='col-md-12'>
                        <div className='mb-3'>
                          <label htmlFor='fullName' className='form-label'>
                            Name on card
                          </label>
                          <input
                            type='number'
                            name='nameOnCard'
                            className='form-control'
                            id='fullName'
                            required
                          />
                        </div>
                      </div> */}
                    {/* Country*/}
                    {/* <div className='col-md-12'>
                        <div className='mb-3'>
                          <label htmlFor='fullName' className='form-label'>
                            Country
                          </label>
                          <input
                            type='text'
                            name='country'
                            className='form-control'
                            id='fullName'
                            required
                          />
                        </div>
                      </div> */}
                    {/* Address*/}
                    {/* <div className='col-md-12'>
                        <div className='mb-3'>
                          <label htmlFor='fullName' className='form-label'>
                            Address
                          </label>
                          <input
                            type='text'
                            name='address'
                            className='form-control'
                            id='fullName'
                            required
                          />
                        </div>
                      </div> */}

                    {/* City*/}
                    {/* <div className='col-md-12'>
                        <div className='mb-3'>
                          <label htmlFor='fullName' className='form-label'>
                            City
                          </label>
                          <input
                            type='text'
                            name='city'
                            className='form-control'
                            id='fullName'
                            required
                          />
                        </div>
                      </div> */}
                  </div>
                </div>
                <div className='col-md-12 col-lg-6'>
                  <div className='row'>
                    {/* <div className='col-md-6'>
                        <div className='mb-3'>
                          <label htmlFor='fullName' className='form-label'>
                            Expire
                          </label>
                          <input
                            type='text'
                            className='form-control input_height'
                            id='fullName'
                            required
                          />
                        </div>
                      </div> 
                      <div className='col-md-6'>
                        <div className='mb-3'>
                          <label htmlFor='fullName' className='form-label'>
                            CCV
                          </label>
                          <input
                            type='text'
                            className='form-control input_height'
                            id='fullName'
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-6 position-relative mt-md-4'>
                        <div className='mb-3'>
                          <label htmlFor='fullName' className='form-label'>
                            State
                          </label>
                          <StateSelectOption />
                        </div>
                      </div>
                      <div className='col-md-6 mt-md-4'>
                        <div className='mb-3'>
                          <label htmlFor='fullName' className='form-label'>
                            ZIP code
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            id='fullName'
                            required
                          />
                        </div>
                      </div> */}
                  </div>
                </div>
              </div>

              <div className='col-md-12'>
                {/*   <span onClick={addmoneytocard}>add money to card</span> */}


                <Elements stripe={stripePromise}>
                  <CheckoutForm />

                </Elements>

              </div>


              {/*  </form>  */}
            </div>

            <div
              className={`tab-pane fade active mt-5 ${paypalid !== "" && stripid == "" ? 'show' : ''}`}
              id='pills-profile1'
              role='tabpanel'
              aria-labelledby='pills-profile-tab'>


              <div className='w-100'>

                <PayPalButtonComponent payment={paidpayment1.length ? paidpayment1[0].amount : 0} />

              </div>

              {/* <div className='d-flex w-100'>
                
                                            <div className="">
                                                      <button className='nav-link bg-white borderbankbtn' type='button'> 
                                                            <i class="fa fa-university" aria-hidden="true"></i>
                                                            <p className='m-0'><h6>Ending in 0000</h6></p>
                                                      
                                                      </button>
                                                      
                                            </div> 
                                            <div className='icon-box icon-box-add-bank' role='button'>
                                                            <span>
                                                              <i className='fa-solid fa-plus'></i>
                                                            </span>
                                            </div> 

                                            <div className='icon-box icon-box-add-bank-edit bg-white' role='button'>
                                                            <span>
                                                               <h6>Edit</h6>
                                                            </span>
                                            </div> 
              </div>
              
              <div className="gap"></div>

              <div className='d-flex w-100'>Would you like to leave a tip?</div>
              <div className='d-flex w-100 border '>
                
                                            <div className="tipdiv ">
                                                      <button className='nav-link bg-white tipbtn active' type='button'> 
                                                                 No thanks
                                                      </button>
                                                      
                                            </div> 
                                            <div className="tipdiv">
                                                       <button className='nav-link bg-white tipbtn' type='button'> 
                                                               10%<br/>
                                                               $10 
                                                      </button>
                                            </div> 

                                            <div className="tipdiv">
                                                         <button className='nav-link bg-white tipbtn' type='button'> 
                                                         15%<br/>
                                                         $15 
                                                         </button>
                                            </div> 
                                            <div className="tipdiv">
                                                       <button className='nav-link bg-white tipbtn' type='button'> 
                                                                20%<br/>
                                                                $20
                                                       </button>
                                            </div> 

                                            <div className="tipdiv">
                                                         <button className='nav-link bg-white tipbtn' type='button'> 
                                                                 Custom
                                                         </button>
                                            </div> 
            </div>

            <div className="gap"></div>


            <div className='d-flex w-100  '>
            <img  src="/img/autopay.png" alt="Autopay" className="autopayimg"/>
            <p className="autopay">Use Autopay, never make a late payment</p>
            </div>

            <div className='d-flex w-100  '>
                      <input type="checkbox" className="autopaycheckbox" />  
                      <p className="autopay_op">(Optional) Pay this amount now. Upcoming payments will be charged automatically per the invoice payment schedule.</p>
            </div>

            



            <div className="gap"></div>

            <div className='d-flex w-100  justify-content-between '>
                     <div><img  src="/img/ssl.png" alt="SSL"/></div>
                     <div className="ssl">  
                       We use the same SSL encryption technology<br/> that banks use to protect your sensitive info.
                     </div>
                     <div>
                            <button className='nav-link bg-black tipbtn' type='button'> 
                                    Pay ${props.paidpayment}

                                   
                            </button>
                           
                                                         
                    </div>
            </div>

            

            <div className='d-flex w-100  '>
                               <img class="w-50" src="/img/paymentmethods.png" alt="Payment Methods"/>
            </div>
             */}

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(CreateInvoicePayContent);
